import { cspController } from '@/apis/core';

export const getCspNameAutocompleteOptions = async (value: string) => {
  const suggestions = await cspController.getCspSuggestions({
    prefix: value,
    limit: 20,
  });
  return suggestions.map((suggestion) => suggestion.cspName);
};

export const getCspCompanyNameAutocompleteOptions = async (value: string) => {
  const suggestions = await cspController.getCspSuggestions({
    companyNamePrefix: value,
    limit: 20,
  });
  return suggestions.map((suggestion) => suggestion.cspCompanyName);
};
